import { render, staticRenderFns } from "./IssueVarTable.vue?vue&type=template&id=561f89a1&scoped=true&"
import script from "./IssueVarTable.vue?vue&type=script&lang=js&"
export * from "./IssueVarTable.vue?vue&type=script&lang=js&"
import style0 from "./IssueVarTable.vue?vue&type=style&index=0&id=561f89a1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "561f89a1",
  null
  
)

export default component.exports